import { api } from '@api'
import { AssignationValues, NoteToCreate, Ticket } from '@types'

interface ApproveTicketsResponse {
  ticket: Ticket
}
interface ApproveTicketPayload {
  id: number
  note?: NoteToCreate
  type?: AssignationValues
}

const approveTicket = async ({ id, note, type }: ApproveTicketPayload) => {
  const response = await api.put<ApproveTicketsResponse>(`/tickets/${id}/approve`, {
    note: { ...note },
    type,
  })

  return response.data
}

export const TicketsApi = { approveTicket }
